import { LockAlertOutlineIcon } from './LockAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 6DE0B795-B0C1-4CFC-A47E-0D1C3A203248
 * name lock-alert-outline
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 * - Lock 
 */
export const LockWarningOutlineIcon = LockAlertOutlineIcon;
export default LockWarningOutlineIcon